import { FilterType } from '@lib/users.interface';

import { ITableColumnConfig } from './helper';
import { OPT_IN_FILTERS, SIGN_UP_FILTERS } from '@admin/users/users.util';

export enum WELCOME_EMAIL_FILTER {
  ALL = -1,
  HAS_RECEIVED = 1,
  HAVE_NOT_RECEIVED = 0,
};

export enum USER_ORIGIN {
  ALL = -1,
  SOCIUU = 1,
  EXTERNAL = 0,
};

export const COLUMNS: ITableColumnConfig[] = [
  {
    title: '',
    id: 'checkbox',
    align: 'left',
    isEnabled: true,
    type: 'selection',
  },
  {
    id: 'name',
    title: 'Name',
    align: 'left',
    flexDirection: 'col',
    type: 'primarySecondaryText',
    primaryConfig: {
      textConfig: {
        textParts: [
          { key: 'first_name' },
          { text: ' ' },
          { key: 'last_name' },
        ],
        iconConfig: {
          src: 'assets/theme/icons/actimo-logo.png',
          matToolTipIcon: {
            textParts: [
              { text: 'Actimo' },
            ],
          },
          conditionConfig: {
            key: 'is_external',
            matchedValue: true,
            conditionType: 'equal'
          }
        },
        pillConfig: [
          {
            color: 'green',
            icon: 'linkedin',
            iconSize: 'icon-size-2',
            matToolTipText: {
              textParts: [
                { text: 'User is social connected to LinkedIn' },
              ],
            },
            conditionConfig: {
              key: 'is_social_connected',
              matchedValue: 1,
              conditionType: 'equal'
            }
          },
        ],
      },
    },
    secondaryConfig: {
      textConfig: {
        textParts: [
          { key: 'email' },
        ],
      },
    },
    sortConfig: {
      isSortable: true,
    },
    isEnabled: true,
  },
  {
    id: 'role',
    title: 'Role',
    align: 'left',
    type: 'pill',
    pillConfig: [
      {
        color: 'yellow',
        textConfig: {
          textParts: [
            { text: 'Super Admin' },
          ],
        },
        conditionConfig: {
          key: 'user_type_id',
          matchedValue: 1,
          conditionType: 'equal'
        }
      },
      {
        color: 'purple',
        textConfig: {
          textParts: [
            { text: 'Admin' },
          ],
        },
        conditionConfig: {
          key: 'user_type_id',
          matchedValue: 2,
          conditionType: 'equal'
        }
      },
      {
        color: 'gray',
        textConfig: {
          textParts: [
            { text: 'Regular User' },
          ],
        },
        conditionConfig: {
          key: 'user_type_id',
          matchedValue: 3,
          conditionType: 'equal'
        }
      },
    ],
    isEnabled: true,
  },
  {
    id: 'welcome_email',
    title: 'Welcome Email',
    type: 'pill',
    align: 'center',
    pillConfig: [
      {
        color: 'red',
        icon: 'feather:x',
        matToolTipText: {
          textParts: [
            { text: 'Has not received welcome email' },
          ],
        },
        conditionConfig: {
          key: 'welcome_email',
          matchedValue: false,
          conditionType: 'equal'
        }
      },
      {
        color: 'green',
        icon: 'feather:check',
        matToolTipText: {
          textParts: [
            { text: 'Has received welcome email' },
          ],
        },
        conditionConfig: {
          key: 'welcome_email',
          matchedValue: true,
          conditionType: 'equal'
        }
      },
    ],
    isEnabled: true,
  },
  {
    id: 'is_opt_in_email_sent',
    title: 'Opt-in Email',
    type: 'pill',
    align: 'center',
    pillConfig: [
      {
        color: 'red',
        icon: 'feather:x',
        matToolTipText: {
          textParts: [
            { text: 'Has not received opt-in email' },
          ],
        },
        conditionConfig: {
          key: 'is_opt_in_email_sent',
          matchedValue: false,
          conditionType: 'equal'
        }
      },
      {
        color: 'green',
        icon: 'feather:check',
        matToolTipText: {
          textParts: [
            { text: 'Has received opt-in email' },
          ],
        },
        conditionConfig: {
          key: 'is_opt_in_email_sent',
          matchedValue: true,
          conditionType: 'equal'
        }
      },
    ],
    isEnabled: false,
  },
  {
    id: 'subscribed',
    title: 'Subscribed',
    align: 'center',
    type: 'pill',
    pillConfig: [
      {
        color: 'red',
        icon: 'feather:x',
        matToolTipText: {
          textParts: [
            { text: 'Unsubscribed' },
          ],
        },
        conditionConfig: {
          key: '_unsubscribed',
          matchedValue: 1,
          conditionType: 'equal'
        }
      },
      {
        color: 'green',
        icon: 'feather:check',
        matToolTipText: {
          textParts: [
            { text: 'Subscribed' },
          ],
        },
        conditionConfig: {
          key: '_unsubscribed',
          matchedValue: 0,
          conditionType: 'equal'
        }
      },
    ],
    isEnabled: true,
  },
  {
    id: 'user_groups',
    title: 'User Groups',
    type: 'selectDropdown',
    align: 'left',
    menuKey: 'usergroups',
    selectDropdownConfig: {
      type: 'usergroup',
      firstBatchData: null,
      isSearchEnabled: true,
      isLoadMoreDisabled: true,
      isDeletionDisabled: false,
      isMultiSelectEnabled: true,
      isSubmitButtonEnabled: false,
      isEmitImmediatelyEnabled: true,
      isCreateNewEntityEnabled: true,
    },
    isEnabled: true,
  },
  {
    id: 'department',
    title: 'Department',
    type: 'selectDropdown',
    align: 'left',
    menuKey: 'department',
    selectDropdownConfig: {
      type: 'department',
      firstBatchData: null,
      isSearchEnabled: true,
      isDeletionDisabled: true,
      isLoadMoreDisabled: true,
      isMultiSelectEnabled: false,
      isSubmitButtonEnabled: false,
      isEmitImmediatelyEnabled: true,
      isCreateNewEntityEnabled: false,
    },
    isEnabled: true,
  },
  {
    id: 'invited',
    title: 'Invited',
    headerTooltip: {
      defaultText: 'Number of times the user has been invited to share content.',
      textParts: [],
    },
    align: 'right',
    type: 'text',
    textConfig: {
      textParts: [
        { key: 'invited' },
      ],
    },
    sortConfig: {
      isSortable: true,
    },
    isEnabled: false,
  },
  {
    id: 'opened',
    title: 'Opened',
    align: 'right',
    type: 'text',
    headerTooltip: {
      defaultText: 'Number of total opened invites to share content.',
      textParts: [],
    },
    textConfig: {
      textParts: [
        { key: 'opened' },
      ],
    },
    sortConfig: {
      isSortable: true,
    },
    isEnabled: false,
  },
  {
    id: 'comments',
    title: 'Comments',
    headerTooltip: {
      defaultText: 'Number of comments made on user\'s posts',
      textParts: [],
    },
    align: 'right',
    type: 'text',
    textConfig: {
      textParts: [
        { key: 'social_connect_comments_count' },
      ],
    },
    sortConfig: {
      isSortable: false,
    },
    isEnabled: true,
  },
  {
    id: 'reactions',
    title: 'Reactions',
    headerTooltip: {
      defaultText: 'Number of all reactions on user\'s posts (likes, support, love etc.)',
      textParts: [],
    },
    align: 'right',
    type: 'text',
    textConfig: {
      textParts: [
        { key: 'social_connect_reactions_count' },
      ],
    },
    sortConfig: {
      isSortable: false,
    },
    isEnabled: true,
  },
  // {
  //   id: 'unique_share_count',
  //   title: 'Unique Share Count',
  //   headerTooltip: {
  //     defaultText: 'Number of times the user has shared content at least once.',
  //     textParts: [],
  //   },
  //   align: 'right',
  //   type: 'text',
  //   textConfig: {
  //     textParts: [
  //       { key: 'unique_share_count' },
  //     ],
  //   },
  //   sortConfig: {
  //     isSortable: true,
  //   },
  //   isEnabled: false,
  // },
  // {
  //   id: 'unique_share_count_pull',
  //   title: 'Unique Share Count Pull',
  //   headerTooltip: {
  //     defaultText: 'Number of times the user has shared content at least once from the SociuuHub.',
  //     textParts: [],
  //   },
  //   align: 'right',
  //   type: 'text',
  //   textConfig: {
  //     textParts: [
  //       { key: 'unique_share_count_pull' },
  //     ],
  //   },
  //   sortConfig: {
  //     isSortable: true,
  //   },
  //   isEnabled: false,
  // },
  {
    id: 'share_count',
    title: 'Share Count',
    headerTooltip: {
      defaultText: 'Number of all user shares and share attempts via email, SMS etc. Brackets show confirmed shares, verified via social connection or clicks on live link post.',
      textParts: [],
    },
    align: 'right',
    type: 'text',
    textConfig: {
      textParts: [
        { key: 'total_shares_count' },
        { text: ' (' },
        { key: 'confirmed_shares_count' },
        { text: ')' },
      ],
    },
    sortConfig: {
      isSortable: false,
    },
    isEnabled: false,
  },
  {
    id: 'share_count_pull',
    title: 'Share Count Pull',
    headerTooltip: {
      defaultText: 'Number of all user shares and share attempts via SociuuHub. Brackets show confirmed shares, verified via social connection or clicks on live link post.',
      textParts: [],
    },
    align: 'right',
    type: 'text',
    textConfig: {
      textParts: [
        { key: 'total_shares_count_pull' },
        { text: ' (' },
        { key: 'confirmed_shares_count_pull' },
        { text: ')' },
      ],
    },
    sortConfig: {
      isSortable: false,
    },
    isEnabled: false,
  },
  // {
  //   id: 'share_count_pull',
  //   title: 'Share Count Pull',
  //   headerTooltip: {
  //     defaultText: 'Number of all user shares and share attempts via SociuuHub. Brackets show confirmed shares, verified via social connection or clicks on live link post.',
  //     textParts: [],
  //   },
  //   align: 'right',
  //   type: 'text',
  //   textConfig: {
  //     textParts: [
  //       { key: 'share_count_pull' },
  //     ],
  //   },
  //   sortConfig: {
  //     isSortable: true,
  //   },
  //   isEnabled: false,
  // },
  {
    id: 'click_count',
    title: 'Click Count',
    headerTooltip: {
      defaultText: 'Total clicks the user has received on their social media posts, counted only if the post contains a clickable link.',
      textParts: [],
    },
    align: 'right',
    type: 'text',
    textConfig: {
      textParts: [
        { key: 'click_count' },
      ],
    },
    sortConfig: {
      isSortable: true,
    },
    isEnabled: false,
  },
  {
    id: 'click_count_pull',
    title: 'Click Count Pull',
    headerTooltip: {
      defaultText: 'Total clicks the user has received on their social media posts, shared directly from the SociuuHub.',
      textParts: [],
    },
    align: 'right',
    type: 'text',
    textConfig: {
      textParts: [
        { key: 'click_count_pull' },
      ],
    },
    sortConfig: {
      isSortable: true,
    },
    isEnabled: false,
  },
  {
    id: 'emv',
    title: 'EMV',
    headerTooltip: {
      defaultText: 'The earned media value the user has generated, calculated based on cost per click.',
      textParts: [],
    },
    align: 'right',
    type: 'text',
    textConfig: {
      textParts: [
        { key: 'emv' },
      ],
    },
    sortConfig: {
      isSortable: true,
    },
    isEnabled: true,
  },
  {
    id: 'fc',
    title: 'FC',
    headerTooltip: {
      defaultText: 'The maximum number of messages a user can receive within a set time period: daily, weekly, or monthly.',
      textParts: [],
    },
    align: 'right',
    type: 'text',
    textConfig: {
      defaultText: 'N/A',
      textParts: [
        { key: 'frequency_cap_data.sent' },
        { text: ' / ' },
        { key: 'frequency_cap_data.limit' },
      ],
    },
    sortConfig: {
      isSortable: true,
    },
    isEnabled: true,
  },
  {
    id: 'created_at',
    title: 'Created',
    align: 'right',
    type: 'date',
    textConfig: {
      textParts: [
        { key: 'created_at' },
      ],
    },
    sortConfig: {
      isSortable: true,
      isSortActive: true,
      sortDirection: 'desc',
    },
    isEnabled: true,
  },
  {
    id: 'action_buttons',
    title: 'Action',
    align: 'center',
    type: 'text',
    sortConfig: {
      isSortable: false,
    },
    isEnabled: true,
  },
];

export const BECOME_USER_EXPIRE_TIME_IN_MINUTES: number = 30;
export const ENABLED_COLUMNS: string[] = [...COLUMNS]
  .filter((column: ITableColumnConfig) => column.isEnabled)
  .map((column: ITableColumnConfig) => column.id);

export const COLUMNS_LIST = (tab: FilterType, isIndividualStatEnabled: boolean): ITableColumnConfig[] => {
  if (tab === 'active') {
    return COLUMNS.filter((column: ITableColumnConfig): boolean => {
      if (isIndividualStatEnabled) return FULL_USERS_COLUMNS.includes(column.id);
      else return BASE_ACTIVE_USERS_COLUMNS.includes(column.id);
    });
  }

  if ([OPT_IN_FILTERS.PENDING, OPT_IN_FILTERS.DECLINE, OPT_IN_FILTERS.EMAIL].includes(tab as OPT_IN_FILTERS)) {
    return COLUMNS.filter((column: ITableColumnConfig): boolean => {
      return OPT_IN_USER_COLUMNS.includes(column.id);
    })
  }

  if ([SIGN_UP_FILTERS.ADMIN_PENDING, SIGN_UP_FILTERS.SIGNUP_REJECT].includes(tab as SIGN_UP_FILTERS)) {
    return COLUMNS.filter((column: ITableColumnConfig): boolean => {
      return SELF_SIGNUP_USER_COLUMNS.includes(column.id);
    })
  }
  return [];
}

export const BASE_USER_COLUMNS: string[] = [
  'role',
  'name',
  'checkbox',
  'department',
  'created_at',
  'user_groups',
  'action_buttons',
];

export const INDIVIDUAL_STAT_COLUMNS: string[] = [
  'opened',
  'invited',
  'share_count',
  'click_count',
  'click_count_pull',
  'share_count_pull',
  'unique_share_count',
  'unique_share_count_pull',
];

export const BASE_ACTIVE_USERS_COLUMNS: string[] = [
  'fc',
  'emv',
  'subscribed',
  'welcome_email',
  'comments',
  'reactions',
  ...BASE_USER_COLUMNS,
];

export const FULL_USERS_COLUMNS: string[] = [
  ...INDIVIDUAL_STAT_COLUMNS,
  ...BASE_ACTIVE_USERS_COLUMNS,
];

export const OPT_IN_USER_COLUMNS: string[] = [
  ...BASE_USER_COLUMNS,
  'is_opt_in_email_sent',
];

export const SELF_SIGNUP_USER_COLUMNS: string[] = [
  ...BASE_USER_COLUMNS,
];


// type: 'pills',
// pills: [
//   {
//     pillConfig: [
//       {
//         color: 'red',
//         textConfig: {
//           textParts: [
//             { key: 'emv' }, //Object key for actual value
//             { text: ' Usergroups' },
//           ],
//         },
//       },
//     ]
//   },
//   {
//     pillConfig: [
//       {
//         color: 'green',
//         textConfig: {
//           textParts: [
//             { key: 'click_count_pull' },
//             { text: ' Sources' },
//           ],
//         },
//       },
//     ]
//   },
// ],

  // {
  //   id: 'image',
  //   title: '',
  //   type: 'image',
  //   imageConfig: {
  //     src: {
  //       textParts: [
  //         { text: 'https://so-assets-images.obs.eu-de.otc.t-systems.com/ytwa3RUULYS1IotB.png' }
  //       ]
  //     }
  //   },
  //   sortConfig: {
  //     isSortable: false,
  //   },
  //   isEnabled: true,
  // },

  // {
  //   id: 'last_name',
  //   title: 'Testing Links',
  //   type: 'primarySecondaryText',
  //   primaryConfig: {
  //     textConfig: {
  //       textParts: [
  //         { key: 'first_name' },
  //         { text: ' ' },
  //         { key: 'last_name' },
  //       ],
  //     },
  //     isLinkEnabled: true,
  //     linkConfig: {
  //       textConfig: {
  //         textParts: [
  //           { key: 'first_name' },
  //           { text: ' ' },
  //           { key: 'last_name' },
  //         ]
  //       },
  //       href: {
  //         textParts: [
  //           { text: '/dashboard' },
  //         ]
  //       }
  //     }
  //   },
  //   secondaryConfig: {
  //     textConfig: {
  //       textParts: [
  //         { key: 'email' },
  //       ],
  //     },
  //   },
  //   sortConfig: {
  //     isSortable: true,
  //   },
  //   isEnabled: true,
  // },
